import {
	type AgentAssignedListItemResponseDTO,
	UserTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";

export const getAgentAdvisors = (
	advisors: AgentAssignedListItemResponseDTO[],
) => advisors.filter((advisor) => advisor.type === UserTypeEnum.Agent);
